import React from "react";
import { useNavigate } from "react-router-dom";
import { createPhnSubscriptionPlan } from "src/actions/callrecorder/phnSubscriptionPlansActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams, PhnSubscriptionPlanInterface } from "src/store/callrecorder/phnSubscriptionPlansSlice";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.newParams);
  const error = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: PhnSubscriptionPlanInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createPhnSubscriptionPlan(data));

    if (createPhnSubscriptionPlan.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-phn-subscription-plan'>
        <h6 className="v-content-label">Create Plan</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
